/* Small patches to the review widget that are cheaper here than a rewrite.
   1. Photo wall uses the real customer shots from IF_REVIEW_PHOTOS.
   2. The rating bars rendered empty: the fill colour was only in the
      stylesheet and the theme's own rules won. Inline it instead. */
(function(){
var P=window.IF_REVIEW_PHOTOS||[];

function patchPhotos(){
if(!P.length)return;
var grid=document.querySelector('.ifgrid');
if(!grid||grid.getAttribute('data-if-ph'))return;
var more=grid.querySelector('.ifgm');
var tiles=grid.querySelectorAll('.ifgi');
if(!tiles.length)return;
grid.setAttribute('data-if-ph','1');
for(var i=0;i<tiles.length;i++)tiles[i].parentNode.removeChild(tiles[i]);
var html='';
P.forEach(function(src){
html+='<div class="ifgi"><img src="'+src+'" alt="Customer photo" loading="lazy"></div>';
});
if(more)more.insertAdjacentHTML('beforebegin',html);
else grid.insertAdjacentHTML('beforeend',html);
}

function patchBars(){
var fills=document.querySelectorAll('.ifbfi');
for(var i=0;i<fills.length;i++){
var f=fills[i];
if(f.getAttribute('data-if-fix'))continue;
f.setAttribute('data-if-fix','1');
var w=f.style.width||'0%';
f.setAttribute('style','height:12px; border-radius:6px; background:#FF4D14; display:block; width:'+w+';');
}
var tracks=document.querySelectorAll('.ifbtr');
for(var t=0;t<tracks.length;t++){
tracks[t].setAttribute('style','flex:1; height:12px; border-radius:6px; background:#E3E7EC; overflow:hidden; min-width:0;');
}
}

function run(){patchPhotos();patchBars();}
var n=0;
var iv=setInterval(function(){n++;run();if(n>60)clearInterval(iv);},160);
if(document.readyState!=='loading')run();else document.addEventListener('DOMContentLoaded',run);
})();
